import classnames from 'classnames';
import type { FunctionComponent } from 'react';
import { translate } from '@/domains/core/localization/translate';
import type { SeoLink } from '@/domains/productDiscovery/microservices/msfProductListing/interfaces/processedData';
import { ChipLink } from '../ChipLink/ChipLink';
import { childrenClassName, ListingLayoutCarousel } from '../ListingLayoutCarousel/ListingLayoutCarousel';
import styles from './SeoLinks.module.scss';
export interface SeoLinksProps {
  values: SeoLink[];
  className?: string;
}
const {
  title
} = translate({
  "title": "You may also like"
});
export const SeoLinks: FunctionComponent<SeoLinksProps> = ({
  className,
  values
}) => {
  const rootClassnames = classnames(styles.root, className);
  return <ListingLayoutCarousel className={rootClassnames} sliderClassName={styles.slider} title={title} dataTestId="seo-links">
      {values.map(({
      name,
      url
    }, index) => <ChipLink id={`seo-link-${index}`} key={`${name}-${url}`} href={url} label={name} className={classnames(styles.chip, childrenClassName)} theme="outline" />)}
    </ListingLayoutCarousel>;
};
SeoLinks.displayName = 'SeoLinks';